<div class="sdp-settings">
	<h2>
		{{ "settings.title" | translate }}
	</h2>
	<div class="sdp-settings-header-description">{{ "settings.description" | translate }}
	</div>

	<mat-card>
		<sdp-name-change></sdp-name-change>
	</mat-card>
	<div class="sdp-card-seperator"></div>
	<sdp-mfa></sdp-mfa>
	<div
		class="sdp-card-seperator"
		*ngIf="this.accountInfo?.limits.isMfaEnabled"
	></div>
	<sdp-reset-password></sdp-reset-password>
	<div class="sdp-card-seperator"></div>
	<mat-card *ngIf="isAdmin">
		<sdp-skip-wizard></sdp-skip-wizard>
	</mat-card>
</div>